module.exports = __webpack_public_path__ + "h5/img/address2.d4531799.png";